export const isAuditSuperAdmin = (user) =>
  user?.is_superadmin === true || Number(user?.is_superadmin) === 1;

export const resolveAuditScopeContext = ({
  user,
  requestedScope = "company",
  selectedCompany,
}) => {
  const isSuperAdmin = isAuditSuperAdmin(user);
  const scope =
    isSuperAdmin && requestedScope === "all" ? "all" : "company";
  const companyId = selectedCompany || null;

  return {
    isSuperAdmin,
    scope,
    companyId,
    scopeKey: scope === "all" ? "all" : `company:${companyId || "none"}`,
  };
};

export const auditScopeQuery = (scope) =>
  scope === "all" ? { scope: "all" } : {};
